import { Component, Input, OnInit } from '@angular/core';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { untilDestroyed } from '@ngneat/until-destroy';
import { JUser } from '@ascschool/interface/user';
import { JSetting } from '@ascschool/interface/setting';
import { ButtonType } from '@ascschool/interface/setting';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-setting-drawer',
  templateUrl: './setting-drawer.component.html',
  styleUrls: ['./setting-drawer.component.scss']
})
export class SettingDrawerComponent implements OnInit {
  settings: JSetting;
  radioValue = 'A';
  switchValue = false;
  date = null;
  listOfOption: string[] = [];
  listOfSelectedValue = ['a10', 'c12'];
  userSettingForm: FormGroup;
  @Input() value = '';
  visible = false;
  btnType: ButtonType;
  ButtonTypeEnum = ButtonType;
  constructor(
    private drawerRef: NzDrawerRef<string>,
    private notification: NzNotificationService,
    private fb: FormBuilder,
    private authService: AuthService,
    private authQuery: AuthQuery,
    private message: NzMessageService
  ) {
    this.userSettingForm = this.fb.group({
      positionMenuNav: [''],
      positionInfoNav: [''],
      hiddenInfoNav: [''],
      btnType: [''],
      ngonNgu: ['1']
    });
  }

  ngOnInit() {
    this.authQuery.userSetting$.subscribe((setting) => {
      this.settings = setting;
    });
    this.authQuery.btnType$.subscribe((setting) => {});
    this.userSettingForm.controls['positionMenuNav'].setValue(this.settings.positionMenuNav);
    this.userSettingForm.controls['positionInfoNav'].setValue(this.settings.positionInfoNav);
    this.userSettingForm.controls['hiddenInfoNav'].setValue(this.settings.hiddenInfoNav);
    this.userSettingForm.controls['btnType'].setValue(this.settings.btnType);
  }
  submitForm(value): void {
    if (value.btnType !== this.settings.btnType) {
      this.authService.getUpdateSettingInfo(value);
      location.reload();
    } else {
      this.authService.getUpdateSettingInfo(value);
    }
    this.message.create('success', `Cập nhật thông tin thành công`);
    this.authService.emitNavChangeEvent();
  }
  resetForm(e: MouseEvent): void {
    e.preventDefault();
  }
  onsubmit(): void {
    this.drawerRef.close(this.value);
  }
  close(e: MouseEvent) {
    e.preventDefault();
    this.userSettingForm.reset();
    this.drawerRef.close(this.value);
  }
  onChange(result: Date[]): void {
  }
}
